<template>
  <div>
    <div v-if="!showContent" class="content-loading">
      <base-loading color="var(--default)" />
    </div>

    <div v-if="showContent" class="content">
      <div class="content__title-buttons" v-if="result.data">
        <base-title title="">
          <base-button
            @click="drawers.filter.open = !drawers.filter.open"
            text="Filtrar avaliações"
            :class="!!isMobile ? 'reverse w-100 mb_15' : 'ml_15'"
            design="two"
          >
            <p class="filter" v-if="!isMobile">
              <i class="fal fa-sliders-h"></i>
            </p>
            <p class="filter" v-else>Filtro e condições</p>
          </base-button>
          <base-button
            @click="drawers.period.open = !drawers.period.open"
            title="Definir periodo"
            :class="!!isMobile ? 'reverse w-100 mb_15' : 'ml_15'"
            design="two"
          >
            <p class="filter" v-if="!isMobile">
              <i class="fal fa-calendar-day"></i>
            </p>
            <p class="filter" v-else>Filtrar intervalo</p>
          </base-button>
        </base-title>
      </div>
      <base-box :class="!isMobile && 'mb_40'" v-if="result.total">
        <div class="d-flex justify-between align-center mb_5 flex-wrap">
          <div class="d-flex align-center">
            <base-label text="Buscar pedido" class="mb_0" />
            <span class="tag period" v-if="!noPeriod && !isMobile">
              {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
              <i @click="removePeriod" class="fal fa-times remove-filter"></i>
            </span>
          </div>
          <span class="tag">{{ result.total }} ocorrências</span>

          <span class="tag period" v-if="!noPeriod && !!isMobile">
            {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
            <i @click="removePeriod" class="fal fa-times remove-filter"></i>
          </span>
        </div>

        <base-input
          :placeholder="'Procure por cliente, telefone ou nº.'"
          class="w-100 mb_0"
          v-model="term"
          @keyup="loading = true"
          @input="isTyping = true"
        />
        <div v-if="isMobile && showTags" class="tags-mobile mt_15">
          <p class="tag">{{ result.total }} ocorrências</p>
          <p class="tag" v-if="!noPeriod">
            {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}`
            }}<i class="fal fa-times remove-filter"></i>
          </p>
          <p class="tag" v-if="filtersData.length > 0">
            {{ filtersData.length }}
            {{
              filtersData.length == 1 ? 'filtro aplicado' : 'filtros aplicados'
            }}<i @click="removeFilters" class="fal fa-times remove-filter"></i>
          </p>
        </div>
      </base-box>

      <div class="row">
        <base-empty
          v-if="!result.data && !dataResult"
          title="Não há nenhum pedido finalizado."
          message="Todos os seus pedidos finalizados irão aparecer aqui."
        />

        <div
          v-else
          class="col-lg-4 col-md-6 col-xs-12 box-negative"
          :class="!isMobile && 'box-format'"
          v-for="(item, index) in result.data"
          :key="index"
          @click="selectOrder(item)"
        >
          <base-box class="box-order">
            <div class="header">
              <p class="field-title order-number">#{{ item.order_id }}</p>
              <verified-badge
                v-if="item.origin == 1"
                :type="item.origin"
                title="Pedido online"
              />
            </div>
            <div class="box-order__content">
              <div class="d-flex align-center justify-between mb_25">
                <div>
                  <p class="field-title">Data</p>
                  <p>
                    {{ dayjs(item.created_at).format('DD/MM/YYYY (HH:mm)') }}
                  </p>
                </div>
                <div class="text-right">
                  <p class="field-title">Cliente</p>
                  <p class="text-capitalize">
                    {{
                      item.payers[0].user
                        ? Utils.capitalize(item.payers[0].user.name)
                        : StringLanguage.customerNotAssigned
                    }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-center justify-between">
                <div>
                  <p class="field-title">Status</p>
                  <p>{{ getStatus(item.status) }}</p>
                </div>
                <div class="text-right">
                  <p class="field-title">Valor</p>
                  <p>{{ Utils.convertMoney(item.total_amount) }}</p>
                </div>
              </div>
            </div>
          </base-box>
        </div>
      </div>

      <infinite-loading spinner="wavedots" @infinite="infiniteHandler">
        <div slot="no-more"></div>
        <div slot="no-results">Sem resultado</div>
      </infinite-loading>

      <filter-period
        :open="drawers.period.open"
        :close="drawers.period.close"
        @filter="filterPeriod"
        :maxCustomRange="0"
      />

      <base-drawer
        title="Filtros e condições"
        :open="drawers.filter.open"
        :close="drawers.filter.close"
      >
        <base-card>
          <base-label text="Defina condições" class="mb_25" />
          <base-checkbox
            :checked="conditions.coupom.active"
            v-model="conditions.coupom.active"
            label="Pedidos com cupom"
            class="mb_15 o-80"
          />
          <!-- OCB
          <base-checkbox
            :checked="conditions.cashback.active"
            v-model="conditions.cashback.active"
            label="Pedidos com cashback"
            class="mb_15 o-80"
          />
          <base-checkbox
            :checked="conditions.addition.active"
            v-model="conditions.addition.active"
            label="Pedidos com acréscimo manual"
            class="mb_15 o-80"
          />
          <base-checkbox
            :checked="conditions.discount.active"
            v-model="conditions.discount.active"
            label="Pedidos com desconto manual"
            class="mb_15 o-80"
          />
          <base-checkbox
            :checked="conditions.is_edited.active"
            v-model="conditions.is_edited.active"
            label="Pedidos editados"
            class="o-80"
          />
          FIM OCB-->
        </base-card>

        <base-card>
          <base-label text="Defina filtros" class="mb_20" />
          <!-- OCB <base-select title="Atendente" v-model="filters.employee">
            <option value="0" selected>Todos</option>
            <option
              :value="oUser.name"
              v-for="(oUser, iUser) in aUsers"
              :key="iUser"
            >
              {{ oUser.name }}
            </option>
          </base-select>

          <base-select title="Origem do pedido" v-model="filters.origin">
            <option value="0" selected>Todas</option>
            <option :value="1">Online</option>
            <option :value="3">Telefone</option>
            <option :value="2">Balcão</option>
          </base-select> OCB -->

          <base-select
            title="Status do pedido"
            class="mb_5"
            v-model="filters.status"
          >
            <option value="0" selected>Todos</option>
            <option :value="4">Finalizado</option>
            <option :value="-1">Cancelado</option>
          </base-select>
        </base-card>

        <template v-slot:footer>
          <base-button
            @click="setFiltersAndConditions"
            text="Filtrar"
            class="w-100"
          />
        </template>
      </base-drawer>
      <!-- Drawer Pedido -->
      <base-drawer
        :open="drawers.detail.open"
        :close="drawers.detail.close"
        :title="`${StringLanguage.order} #${this.targetOrder.order_id}`"
      >
        <orders-detail
          :reportRating="true"
          v-if="targetOrder.id"
          :order.sync="targetOrder"
          :catalog="catalog"
          :key="targetOrderReload"
        />
      </base-drawer>
    </div>
  </div>
</template>

<script>
// components
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';
import Builder from 'easyjs/lib/Schema/Components/Builder';
import { Status } from 'easyjs/lib/Schema/Order';
import clusterize from 'vue-clusterize';
import dayjs from 'dayjs';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseEmpty from '@/components/Empty';
import BaseButton from '@/components/Button';
import BaseDrawer from '@/components/Drawer';
import BaseTitle from '@/components/Title';
import BaseCard from '@/components/Card';
import BaseCheckbox from '@/components/Checkbox';
import BaseQuestion from '@/components/Question';
import BaseSelect from '@/components/Select';
import BaseLabel from '@/components/Label';
import BaseLoading from '@/components/Loading';
// containers
import FilterPeriod from '@/containers/FilterPeriod';
import ListItems from '@/containers/ListItems';
import VerifiedBadge from '@/containers/Users/VerifiedBadge';
import OrdersDetail from '@/containers/Orders/OrdersDetail';
// libs
// api
import UserAPI from '@/api/user';
import ApiReports from '@/api/reports';
import CatalogAPI from '@/api/catalog';
// utils
import Utils from '@/utils';

export default {
  components: {
    BaseBox,
    BaseInput,
    BaseEmpty,
    BaseTitle,
    BaseButton,
    BaseDrawer,
    BaseCard,
    BaseCheckbox,
    BaseQuestion,
    BaseSelect,
    BaseLabel,
    BaseLoading,
    FilterPeriod,
    ListItems,
    clusterize,
    InfiniteLoading,
    VerifiedBadge,
    OrdersDetail,
  },
  data() {
    return {
      dayjs,
      Utils,
      loading: false,
      showTags: false,
      isTyping: false,
      page: 1,
      size: 15,
      term: '',
      period: ['1900-01-01', dayjs().format('YYYY-MM-DD')],
      noPeriod: true,
      esFilter: {
        index: 'report-orders',
        type: 'query',
        size: 15,
        from: 0,
        sort: [
          {
            created_at: {
              order: 'desc',
            },
          },
        ],
        queries: [],
      },
      drawers: {
        period: {
          open: false,
          close: false,
        },
        filter: {
          open: false,
          close: false,
        },
        detail: {
          open: false,
          close: false,
        },
      },
      result: {},
      targetOrder: {},
      targetOrderReload: false,
      conditions: {
        coupom: {
          active: false,
          value: 1,
        },
        cashback: {
          active: false,
          value: 2,
        },
        addition: {
          active: false,
          value: 4,
        },
        discount: {
          active: false,
          value: 8,
        },
        is_edited: {
          active: false,
          value: 16,
        },
      },
      filters: {
        employee: false,
        origin: false,
        status: false,
      },
      filtersData: [],
      conditionsValue: 0,
      qtyFiltersApplied: 0,
      users: [],
      aUsers: [],
      userError: null,
      catalog: '',
      showContent: false,
      dataResult: { type: Boolean },
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      currentUser: (state) => state.account.oUser,
    }),
    esDataFilter() {
      const queries = [
        {
          range: {
            created_at: {
              gte: this.period[0],
              lte: this.period[1],
            },
          },
        },
        {
          bool: {
            should: [
              {
                match: {
                  status: 4,
                },
              },
              {
                match: {
                  status: -1,
                },
              },
            ],
          },
        },
      ];

      if (this.term != '') {
        const termIsNumber = /^\d+$/.test(this.term);

        if (termIsNumber) {
          if (this.term.length <= 7) {
            queries.push({
              query_string: {
                query: `*${this.term}*`,
                fields: ['order_id'],
              },
            });
          } else {
            queries.push({
              nested: {
                path: 'payers',
                query: {
                  query_string: {
                    query: `*${this.term.toLowerCase()}*`,
                    fields: ['payers.user.phone'],
                  },
                },
              },
            });
          }
        } else {
          // transoforma o nome em caixa baixa e substitui os espaços por '*'
          const queryName = this.term.toLowerCase().replace(/\s/g, '* AND *');

          queries.push({
            nested: {
              path: 'payers',
              query: {
                query_string: {
                  query: `*${queryName}*`,
                  fields: ['payers.user.name'],
                },
              },
            },
          });
        }
      }

      queries.push({
        bool: {
          should: this.filtersData,
        },
      });

      return {
        query: [
          {
            index: 'report-orders',
            type: 'query',
            size: this.size,
            from: (this.page - 1) * this.size,
            sort: this.sortData,
            queries,
          },
        ],
      };
    },
  },
  created() {
    this.getCatalog();
    this.getUsers();
    return UserAPI.list(false).then((response) => {
      if (response) this.aUsers = response.getData([]);
      return this.aUsers;
    });
  },
  methods: {
    getCatalog() {
      CatalogAPI.catalogCatalog(false).then((catalogResponse) => {
        if (catalogResponse)
          this.catalog = Builder.mountSchema(
            catalogResponse.getData({ type: 'catalog' })
          );
        Builder.executeOnSchema(this.catalog, function (item) {
          item.new = false;
          item.quantity = 0;
        });
        return this;
      });
    },
    formatDate(date) {
      const ds = date.split('T');
      return dayjs(dayjs(`${ds[0]} ${ds[1].split('-')[0]}`)).format(
        'HH:mm [de] DD/MM/YYYY'
      );
    },
    getUsers() {
      const filter = {
        query: [
          {
            index: 'report-orders',
            type: 'aggs',
            aggs: {
              employees: {
                terms: {
                  field: 'employee',
                },
              },
            },
          },
        ],
      };

      ApiReports.reports(filter).then((response) => {
        const { employees } = response.data[0];
        if (employees) {
          this.users = employees.buckets.map((item) => {
            return { name: item.key };
          });
        }
      });
    },
    search(reset = true) {
      const self = this;
      return new Promise((resolve) => {
        if (reset) {
          // this.result.total = 0;
          this.result.data = [];
          this.page = 1;
          this.loading = true;
        }
        ApiReports.reports(this.esDataFilter).then((response) => {
          if (response.data[0]) {
            const data = response.data[0];
            if (data.hits.length > 0) {
              const result = {
                total: data.total.value,
              };
              self.result = { ...self.result, ...result };
              !self.result.data || reset ? (self.result.data = []) : '';

              self.page += 1;

              data.hits.forEach((item) => {
                self.result.data.push(item._source);
              });

              resolve(true);
            } else {
              resolve(false);
            }
          } else {
            resolve(false);
          }
        });
        this.loading = false;
        self.$forceUpdate();
      });
    },
    getStatus(status) {
      switch (status) {
        case Status.IN_PRODUCTION:
          return StringLanguage.inProduction;
          break;
        case Status.ON_DELIVERY:
          return StringLanguage.onDelivery;
          break;
        case Status.FINISHED:
          return StringLanguage.finished;
          break;
        case Status.CANCELLED:
          return StringLanguage.cancelled;
          break;
      }
    },
    selectOrder(order) {
      this.targetOrder = JSON.parse(order.raw);
      this.drawers.detail.open = !this.drawers.detail.open;
      this.targetOrderReload = !this.targetOrderReload;
    },
    infiniteHandler($state) {
      this.search(false).then((result) => {
        this.dataResult = result;

        if (result) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    compositeQueries(filter = []) {
      let queries = [];

      // define range
      queries.push({
        range: {
          created_at: {
            gte: this.period[0],
            lte: this.period[1],
          },
        },
      });

      // define filters
      if (typeof filter !== 'string') {
        queries = queries.concat(filter);
      }

      this.esFilter.queries = queries;
    },
    removeFilters() {
      for (const i in this.conditions) {
        this.conditions[i].active = false;
      }
      for (const i in this.filters) {
        this.filters[i] = false;
      }

      this.setFiltersAndConditions();
    },
    removePeriod() {
      this.noPeriod = true;
      this.period = ['1900-01-01', dayjs().format('YYYY-MM-DD')];
      this.search();
    },
    filterPeriod(period) {
      this.noPeriod = false;
      period.periods[0] = dayjs(period.periods[0]).format(
        'YYYY-MM-DDTHH:mm:ssZ[Z]'
      );
      period.periods[1] = dayjs(period.periods[1]).format(
        'YYYY-MM-DDTHH:mm:ssZ[Z]'
      );
      this.period = period.periods;
      this.result.data = [];
      this.search();
      this.drawers.period.close = !this.drawers.period.close;
    },
    setFiltersAndConditions() {
      this.filtersData = [];
      for (const i in this.conditions) {
        if (this.conditions[i].active) {
          const term = {};
          term[i] = {
            value: true,
          };
          this.filtersData.push({
            term,
          });
        }
      }

      for (const i in this.filters) {
        const activated = !!(
          typeof this.filters[i] === 'string' && this.filters[i] != 'false'
        );
        if (activated) {
          const term = {};
          term[i] = this.filters[i];
          this.filtersData.push({
            match: term,
          });
        }
      }

      this.search();
      this.drawers.filter.close = !this.drawers.filter.close;
    },
  },
  watch: {
    term: Utils.debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping(value) {
      if (!value) {
        this.search();
      }
    },
    aUsers(newValue) {
      if (newValue.length > 0) {
        this.showContent = true;
      }
    },
  },
};
</script>

<style scoped>
.box-order {
  cursor: pointer;
}
.box-order .header {
  font-size: 16px;
  font-weight: bold;
  color: var(--title-card);
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #494949;
  position: relative;
}
.box-order .customer-verify {
  top: -5px;
  right: 0;
}
.field-title.order-number {
  color: var(--title-card);
  font-size: 16px;
}
.field-title {
  font-size: 12px;
  color: var(--title-card);
  font-weight: bold;
  line-height: 15px;
}

.field-title + p {
  font-size: 12px;
  color: var(--title-card);
  line-height: 15px;
  margin-top: 10px;
}
.order-name-badge {
  position: absolute;
  top: 0;
  right: 15px;
  font-size: 1.5em;
  border-radius: 0 5px 0 5px;
  cursor: pointer;
}
.search-box {
  display: flex;
  padding: 7px 20px 2px 20px !important;
}
.tag {
  background: #45484d;
  padding: 5px 10px;
  margin-left: 10px;
  font-weight: 400;
  color: #aaaaab;
  font-size: 14px;
  border-radius: 5px;
  position: relative;
}
.tag.period {
  padding-right: 30px;
}
.tags-mobile .tag {
  margin-left: 0 !important;
  margin-top: 10px;
  padding: 10px 15px;
}
.tags-mobile .tag i {
  float: right;
}
.remove-filter {
  margin-left: 12px;
  font-size: 13px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
}
.toggle-tags {
  margin-right: 10px;
  font-size: 1.3em;
  color: var(--default);
}
.search-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.content-loading {
  height: calc(100vh - 280px);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.content {
  position: relative;
  height: calc(100% - 280px);
}
.content__title-buttons {
  display: flex;
  position: absolute;
  top: -150px;
  right: 0;
}
.button-text {
  font-family: 'Lato';
}
.button-icon {
  font-size: 20px;
  font-weight: 300;
  margin-left: 10px;
}
.box-negative {
  margin-bottom: -10px;
}
.box-format:nth-child(3n + 2) {
  padding-left: 6px !important;
  padding-right: 6px !important;
}

@media screen and (max-width: 991px) {
  .tag {
    font-size: 12px;
  }
  .tag.period {
    margin-top: 15px;
    width: 100%;
    margin-left: 0;
  }
  .content__title-buttons {
    top: -130px;
  }
}
</style>
